module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && _vm.template) ? _c('div', [_c(_vm.template, _vm._b({
    tag: "component"
  }, 'component', _vm.templateProps, false))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-562cda1b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreatePagePage.vue
// module id = 1157
// module chunks = 0